import { Component, Input, OnInit } from '@angular/core';
import { Fieldset } from 'primeng/fieldset';

@Component({
    selector: 'field-tools',
    templateUrl: 'fieldtools.component.html',
    styleUrls: ['fieldtools.component.scss'],
})

export class FieldToolsComponent extends Fieldset implements OnInit {
    @Input() public dataTitle;

    public ngOnInit(){
        
    }
}


